export enum MpPages {
    LOGIN = "login",
    HOME = "home",
    DASHBOARD = "dashboard",
    MISSIONS = "missions",
    STAFF = "staff",
    CALENDAR = "calendar",
    BOARDS = "boards",
    PROFILE = "profile"
}
